import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Check, X, Shield, Zap, Eye, Rocket, Crown, Trophy, ChevronRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function PricingPlans() {
  const {
    currency,
    language
  } = useLanguage();
  const webPlans = [{
    name: 'KINETIC KEEPER',
    icon: Shield,
    price: '19,99',
    badge: null,
    highlighted: false,
    cta: language === 'es' ? 'EMPEZAR' : 'START',
    features: language === 'es' ? ['Mantenimiento técnico y actualizaciones', 'Backups diarios automáticos', 'Soporte por email (24-48h)', '1 cambio de contenido web al mes', '1 diseño profesional para redes'] : ['Technical maintenance and updates', 'Automatic daily backups', 'Email support (24-48h)', '1 web content change per month', '1 professional social media design']
  }, {
    name: 'KINETIC ACTIVE',
    icon: Zap,
    price: '39,99',
    badge: language === 'es' ? 'MÁS ELEGIDO' : 'MOST CHOSEN',
    highlighted: true,
    cta: language === 'es' ? 'QUIERO ESTE ⭐' : 'I WANT THIS ⭐',
    features: language === 'es' ? ['Todo lo del plan Keeper incluido', '4 cambios de contenido web al mes', '4 diseños para redes (1/semana)', 'Stories incluido para cada post', 'Soporte directo por WhatsApp'] : ['Everything in Keeper plan included', '4 web content changes per month', '4 social media designs (1/week)', 'Stories included for each post', 'Direct WhatsApp support']
  }, {
    name: 'KINETIC VISIBILITY',
    icon: Eye,
    price: '69,99',
    badge: null,
    highlighted: false,
    cta: language === 'es' ? 'IR AL VISIBILITY' : 'GO VISIBILITY',
    features: language === 'es' ? ['Todo lo del plan Active incluido', 'Cambios de contenido web ilimitados', '8 diseños para redes (2/semana)', 'Google My Business optimizado', 'Respuesta a reseñas de Google', 'SEO On-Page básico mensual'] : ['Everything in Active plan included', 'Unlimited web content changes', '8 social media designs (2/week)', 'Optimized Google My Business', 'Google reviews response', 'Monthly basic On-Page SEO']
  }];
  const growthPlans = [{
    name: 'KINETIC GROWTH',
    icon: Rocket,
    price: '149,00',
    badge: null,
    highlighted: false,
    cta: language === 'es' ? 'EMPEZAR' : 'START',
    features: language === 'es' ? ['Todo lo del plan Visibility incluido', 'Gestión de Anuncios Pagados (Meta/Google)', 'Configuración de Píxel/Conversiones', 'Reporte semanal de rendimiento de anuncios', 'Cambios web ilimitados'] : ['Everything in Visibility plan included', 'Paid Ads Management (Meta/Google)', 'Pixel/Conversions setup', 'Weekly ads performance report', 'Unlimited web changes']
  }, {
    name: 'KINETIC PROFESSIONAL',
    icon: Crown,
    price: '249,00',
    badge: language === 'es' ? 'MÁS VENDIDO' : 'BEST SELLER',
    highlighted: true,
    cta: language === 'es' ? 'QUIERO ESTE ⭐' : 'I WANT THIS ⭐',
    features: language === 'es' ? ['Todo lo del plan Growth incluido', '12 diseños para redes (3/semana)', 'Chatbot de WhatsApp básico', 'Llamada de estrategia mensual (30 min)', 'Informe detallado tráfico orgánico y pagado'] : ['Everything in Growth plan included', '12 social media designs (3/week)', 'Basic WhatsApp chatbot', 'Monthly strategy call (30 min)', 'Detailed organic and paid traffic report']
  }, {
    name: 'KINETIC DOMINATION',
    icon: Trophy,
    price: '399,00',
    badge: null,
    highlighted: false,
    cta: language === 'es' ? 'IR AL MÁXIMO' : 'GO MAXIMUM',
    features: language === 'es' ? ['Todo lo del plan Professional incluido', '4 Reels/TikToks editados al mes', 'Email Marketing (2 newsletters/mes)', 'Sistema de reseñas automático', 'SEO local avanzado', 'Soporte Prioritario VIP 24/7'] : ['Everything in Professional plan included', '4 edited Reels/TikToks per month', 'Email Marketing (2 newsletters/month)', 'Automated review system', 'Advanced local SEO', 'VIP Priority Support 24/7']
  }];
  const comparisonFeatures = [{
    label: language === 'es' ? 'PRECIO/MES' : 'PRICE/MONTH',
    values: ['€19,99', '€39,99', '€69,99', '€149', '€249', '€399']
  }, {
    label: language === 'es' ? 'Mantenimiento técnico' : 'Technical maintenance',
    values: [true, true, true, true, true, true]
  }, {
    label: language === 'es' ? 'Backups diarios' : 'Daily backups',
    values: [true, true, true, true, true, true]
  }, {
    label: language === 'es' ? 'Soporte email 24h' : 'Email support 24h',
    values: [true, true, true, true, true, true]
  }, {
    label: language === 'es' ? 'Soporte WhatsApp' : 'WhatsApp support',
    values: [false, true, true, true, true, true]
  }, {
    label: language === 'es' ? 'Cambios web' : 'Web changes',
    values: ['1/mes', '4/mes', language === 'es' ? 'Ilimitados' : 'Unlimited', language === 'es' ? 'Ilimitados' : 'Unlimited', language === 'es' ? 'Ilimitados' : 'Unlimited', language === 'es' ? 'Ilimitados' : 'Unlimited']
  }, {
    label: language === 'es' ? 'Diseños para redes' : 'Social designs',
    values: ['1/mes', '4/mes', '8/mes', '8/mes', '12/mes', '12/mes']
  }, {
    label: language === 'es' ? 'Stories para redes' : 'Social stories',
    values: [false, true, true, true, true, true]
  }, {
    label: 'Google My Business',
    values: [false, false, true, true, true, true]
  }, {
    label: language === 'es' ? 'Reseñas Google' : 'Google reviews',
    values: [false, false, true, true, true, true]
  }, {
    label: 'SEO On-Page',
    values: [false, false, true, true, true, true]
  }, {
    label: language === 'es' ? 'Gestión de Ads' : 'Ads management',
    values: [false, false, false, true, true, true]
  }, {
    label: language === 'es' ? 'Píxel/Conversiones' : 'Pixel/Conversions',
    values: [false, false, false, true, true, true]
  }, {
    label: language === 'es' ? 'Reporte semanal' : 'Weekly report',
    values: [false, false, false, true, true, true]
  }, {
    label: language === 'es' ? 'Chatbot WhatsApp' : 'WhatsApp chatbot',
    values: [false, false, false, false, true, true]
  }, {
    label: language === 'es' ? 'Llamada estrategia' : 'Strategy call',
    values: [false, false, false, false, true, true]
  }, {
    label: 'Reels/TikTok',
    values: [false, false, false, false, false, true]
  }, {
    label: 'Email Marketing',
    values: [false, false, false, false, false, true]
  }, {
    label: language === 'es' ? 'Reseñas automáticas' : 'Automated reviews',
    values: [false, false, false, false, false, true]
  }, {
    label: language === 'es' ? 'Soporte VIP 24/7' : 'VIP Support 24/7',
    values: [false, false, false, false, false, true]
  }];
  return <section id="planes" className="py-16 md:py-24 bg-brand-darker relative overflow-hidden" data-id="element-278">
      {/* WEB PLANS SECTION */}
      <div className="container mx-auto px-4 md:px-6 max-w-7xl mb-20 md:mb-32" data-id="element-279">
        <div className="text-center mb-8 md:mb-12" data-id="element-280">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-brand-purple/20 border border-brand-purple/30 rounded-full px-4 py-2 mb-4" data-id="element-281">
            <Shield className="w-4 h-4 text-brand-cyan" data-id="element-282" />
            <span className="text-sm font-bold text-brand-cyan uppercase tracking-wider" data-id="element-283">
              {language === 'es' ? 'Planes Web Bajo Control' : 'Web Plans Under Control'}
            </span>
          </motion.div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-284">
            {language === 'es' ? 'Mantén tu web segura, actualizada' : 'Keep your website secure, updated'}
            <br data-id="element-285" />
            <span className="text-brand-cyan" data-id="element-286">
              {language === 'es' ? 'y siempre funcionando' : 'and always working'}
            </span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-3xl mx-auto" data-id="element-287">
            {language === 'es' ? 'Tu web es tu vendedor número 1. Mantenla siempre activa, rápida y actualizada. Elige el plan que se adapta a tu negocio y olvídate de los problemas técnicos para siempre.' : 'Your website is your #1 salesperson. Keep it always active, fast and updated. Choose the plan that fits your business and forget about technical problems forever.'}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 items-start" data-id="element-288">
          {webPlans.map((plan, index) => {
          const IconComponent = plan.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className={`relative rounded-3xl p-6 md:p-8 ${plan.highlighted ? 'bg-gradient-to-b from-brand-cyan/10 to-brand-bg border-2 border-brand-cyan shadow-[0_0_40px_rgba(0,255,255,0.15)] md:-translate-y-4' : 'bg-brand-bg border border-white/10'}`} data-id="element-289">
                {plan.badge && <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-brand-cyan text-brand-darker font-bold px-4 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap shadow-[0_0_20px_rgba(0,255,255,0.4)]" data-id="element-290">
                    {plan.badge}
                  </div>}

                <div className="text-center mb-6 md:mb-8" data-id="element-291">
                  <div className={`inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl mb-4 ${plan.highlighted ? 'bg-brand-cyan/20' : 'bg-white/5'}`} data-id="element-292">
                    <IconComponent className={`w-8 h-8 md:w-10 md:h-10 ${plan.highlighted ? 'text-brand-cyan' : 'text-gray-400'}`} data-id="element-293" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-4" data-id="element-294">
                    {plan.name}
                  </h3>
                  <div className="flex items-baseline justify-center gap-1" data-id="element-295">
                    <span className="text-2xl md:text-3xl text-gray-400" data-id="element-296">
                      {currency}
                    </span>
                    <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-297">
                      {plan.price}
                    </span>
                    <span className="text-gray-400" data-id="element-298">
                      /{language === 'es' ? 'mes' : 'mo'}
                    </span>
                  </div>
                </div>

                <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-299">
                  {plan.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-300">
                      <Check className={`w-5 h-5 shrink-0 mt-0.5 ${plan.highlighted ? 'text-brand-cyan' : 'text-gray-500'}`} data-id="element-301" />
                      <span className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-302">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <a href="#contacto" className={`group flex items-center justify-center gap-2 w-full text-center font-bold py-4 rounded-xl transition-all duration-300 text-sm md:text-base ${plan.highlighted ? 'bg-brand-cyan hover:bg-brand-cyan/90 text-brand-darker shadow-[0_0_20px_rgba(0,255,255,0.3)] hover:shadow-[0_0_30px_rgba(0,255,255,0.5)]' : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'}`} data-id="element-303">
                  {plan.cta}
                  <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-304" />
                </a>
              </motion.div>;
        })}
        </div>
      </div>

      {/* GROWTH PLANS SECTION */}
      <div className="container mx-auto px-4 md:px-6 max-w-7xl mb-20 md:mb-32" data-id="element-305">
        <div className="text-center mb-8 md:mb-12" data-id="element-306">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-brand-purple/20 border border-brand-purple/30 rounded-full px-4 py-2 mb-4" data-id="element-307">
            <Rocket className="w-4 h-4 text-brand-purple" data-id="element-308" />
            <span className="text-sm font-bold text-brand-purple uppercase tracking-wider" data-id="element-309">
              {language === 'es' ? 'Planes Crecimiento Total' : 'Total Growth Plans'}
            </span>
          </motion.div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-310">
            {language === 'es' ? 'Atrae clientes nuevos con' : 'Attract new customers with'}
            <br data-id="element-311" />
            <span className="text-brand-purple" data-id="element-312">
              {language === 'es' ? 'redes sociales, publicidad y marketing digital' : 'social media, advertising and digital marketing'}
            </span>
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-3xl mx-auto" data-id="element-313">
            {language === 'es' ? 'Una web bonita que nadie ve, no vende. Nosotros hacemos que te encuentren. Desde gestión de redes hasta publicidad pagada. Tú enfócate en tu negocio, nosotros en traerte clientes.' : "A beautiful website that nobody sees, doesn't sell. We make sure they find you. From social media management to paid advertising. You focus on your business, we focus on bringing you customers."}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 items-start" data-id="element-314">
          {growthPlans.map((plan, index) => {
          const IconComponent = plan.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className={`relative rounded-3xl p-6 md:p-8 ${plan.highlighted ? 'bg-gradient-to-b from-brand-purple/20 to-brand-bg border-2 border-brand-purple shadow-[0_0_40px_rgba(139,47,201,0.2)] md:-translate-y-4' : 'bg-brand-bg border border-white/10'}`} data-id="element-315">
                {plan.badge && <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-brand-purple text-white font-bold px-4 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap shadow-[0_0_20px_rgba(139,47,201,0.4)]" data-id="element-316">
                    {plan.badge}
                  </div>}

                <div className="text-center mb-6 md:mb-8" data-id="element-317">
                  <div className={`inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl mb-4 ${plan.highlighted ? 'bg-brand-purple/20' : 'bg-white/5'}`} data-id="element-318">
                    <IconComponent className={`w-8 h-8 md:w-10 md:h-10 ${plan.highlighted ? 'text-brand-purple' : 'text-gray-400'}`} data-id="element-319" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-4" data-id="element-320">
                    {plan.name}
                  </h3>
                  <div className="flex items-baseline justify-center gap-1" data-id="element-321">
                    <span className="text-2xl md:text-3xl text-gray-400" data-id="element-322">
                      {currency}
                    </span>
                    <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-323">
                      {plan.price}
                    </span>
                    <span className="text-gray-400" data-id="element-324">
                      /{language === 'es' ? 'mes' : 'mo'}
                    </span>
                  </div>
                </div>

                <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-325">
                  {plan.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-326">
                      <Check className={`w-5 h-5 shrink-0 mt-0.5 ${plan.highlighted ? 'text-brand-purple' : 'text-gray-500'}`} data-id="element-327" />
                      <span className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-328">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <a href="#contacto" className={`group flex items-center justify-center gap-2 w-full text-center font-bold py-4 rounded-xl transition-all duration-300 text-sm md:text-base ${plan.highlighted ? 'bg-brand-purple hover:bg-brand-purple/90 text-white shadow-[0_0_20px_rgba(139,47,201,0.3)] hover:shadow-[0_0_30px_rgba(139,47,201,0.5)]' : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'}`} data-id="element-329">
                  {plan.cta}
                  <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-330" />
                </a>
              </motion.div>;
        })}
        </div>
      </div>

      {/* COMPARISON TABLE */}
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-331">
        <div className="text-center mb-8 md:mb-12" data-id="element-332">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-333">
            {language === 'es' ? 'Tabla Comparativa' : 'Comparison Table'}
            <span className="text-brand-cyan" data-id="element-334">
              {' '}
              {language === 'es' ? 'Completa' : 'Complete'}
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-400 text-sm md:text-base flex items-center justify-center gap-2" data-id="element-335">
            <ChevronRight className="w-4 h-4 rotate-180" data-id="element-336" />
            {language === 'es' ? 'Desliza para ver la tabla completa' : 'Scroll to see full table'}
            <ChevronRight className="w-4 h-4" data-id="element-337" />
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="overflow-x-auto rounded-2xl border border-white/10 bg-gradient-to-b from-brand-bg to-brand-darker shadow-2xl" data-id="element-338">
          <table className="w-full min-w-[900px]" data-id="element-339">
            <thead data-id="element-340">
              <tr className="border-b border-white/20" data-id="element-341">
                <th className="text-left p-3 md:p-4 font-bold text-sm md:text-base text-white/80 sticky left-0 bg-gradient-to-r from-brand-bg to-brand-bg/95 z-10 backdrop-blur-sm w-48" data-id="element-342">
                  {language === 'es' ? 'Característica' : 'Feature'}
                </th>
                <th className="text-center p-3 md:p-4 font-bold text-xs md:text-sm text-white/90 min-w-[120px]" data-id="element-343">
                  <div className="flex flex-col items-center gap-1" data-id="element-344">
                    <Shield className="w-5 h-5 text-gray-400" data-id="element-345" />
                    <span data-id="element-346">KEEPER</span>
                  </div>
                </th>
                <th className="text-center p-3 md:p-4 font-bold text-xs md:text-sm text-brand-cyan bg-brand-cyan/10 border-x border-brand-cyan/20 min-w-[120px]" data-id="element-347">
                  <div className="flex flex-col items-center gap-1" data-id="element-348">
                    <Zap className="w-5 h-5 text-brand-cyan" data-id="element-349" />
                    <span data-id="element-350">ACTIVE</span>
                    <span className="text-[10px] bg-brand-cyan/20 px-2 py-0.5 rounded-full" data-id="element-351">
                      ★
                    </span>
                  </div>
                </th>
                <th className="text-center p-3 md:p-4 font-bold text-xs md:text-sm text-white/90 min-w-[120px]" data-id="element-352">
                  <div className="flex flex-col items-center gap-1" data-id="element-353">
                    <Eye className="w-5 h-5 text-gray-400" data-id="element-354" />
                    <span data-id="element-355">VISIBILITY</span>
                  </div>
                </th>
                <th className="text-center p-3 md:p-4 font-bold text-xs md:text-sm text-white/90 min-w-[120px]" data-id="element-356">
                  <div className="flex flex-col items-center gap-1" data-id="element-357">
                    <Rocket className="w-5 h-5 text-gray-400" data-id="element-358" />
                    <span data-id="element-359">GROWTH</span>
                  </div>
                </th>
                <th className="text-center p-3 md:p-4 font-bold text-xs md:text-sm text-brand-purple bg-brand-purple/10 border-x border-brand-purple/20 min-w-[120px]" data-id="element-360">
                  <div className="flex flex-col items-center gap-1" data-id="element-361">
                    <Crown className="w-5 h-5 text-brand-purple" data-id="element-362" />
                    <span data-id="element-363">PROFESSIONAL</span>
                    <span className="text-[10px] bg-brand-purple/20 px-2 py-0.5 rounded-full" data-id="element-364">
                      ★
                    </span>
                  </div>
                </th>
                <th className="text-center p-3 md:p-4 font-bold text-xs md:text-sm text-white/90 min-w-[120px]" data-id="element-365">
                  <div className="flex flex-col items-center gap-1" data-id="element-366">
                    <Trophy className="w-5 h-5 text-gray-400" data-id="element-367" />
                    <span data-id="element-368">DOMINATION</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-369">
              {comparisonFeatures.map((feature, index) => <motion.tr key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              delay: index * 0.03,
              duration: 0.3
            }} className="border-b border-white/5 hover:bg-white/5 transition-all duration-300 group" data-id="element-370">
                  <td className="p-3 md:p-4 text-xs md:text-sm text-gray-300 font-medium sticky left-0 bg-gradient-to-r from-brand-bg to-brand-bg/95 z-10 backdrop-blur-sm group-hover:text-white transition-colors" data-id="element-371">
                    {feature.label}
                  </td>
                  {feature.values.map((value, vIndex) => <td key={vIndex} className={`p-3 md:p-4 text-center transition-all duration-300 ${vIndex === 1 ? 'bg-brand-cyan/5 border-x border-brand-cyan/10 group-hover:bg-brand-cyan/10' : vIndex === 4 ? 'bg-brand-purple/5 border-x border-brand-purple/10 group-hover:bg-brand-purple/10' : 'group-hover:bg-white/5'}`} data-id="element-372">
                      {typeof value === 'boolean' ? <motion.div initial={{
                  scale: 0
                }} whileInView={{
                  scale: 1
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.03 + 0.1,
                  type: 'spring',
                  stiffness: 200
                }} className="flex justify-center" data-id="element-373">
                          {value ? <div className="relative" data-id="element-374">
                              <Check className="w-5 h-5 text-green-500 group-hover:scale-110 transition-transform" data-id="element-375" />
                              <div className="absolute inset-0 bg-green-500/20 rounded-full blur-md opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-376" />
                            </div> : <X className="w-5 h-5 text-gray-700 group-hover:text-gray-600 transition-colors" data-id="element-377" />}
                        </motion.div> : <motion.span initial={{
                  opacity: 0
                }} whileInView={{
                  opacity: 1
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.03 + 0.1
                }} className={`text-xs md:text-sm font-medium transition-colors ${index === 0 ? 'text-white font-bold' : 'text-gray-400 group-hover:text-gray-300'}`} data-id="element-378">
                          {value}
                        </motion.span>}
                    </td>)}
                </motion.tr>)}
            </tbody>
          </table>
        </motion.div>

        {/* CTA Below Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-center mt-8 md:mt-12" data-id="element-379">
          <p className="text-gray-400 mb-4" data-id="element-380">
            {language === 'es' ? '¿No estás seguro cuál elegir?' : 'Not sure which one to choose?'}
          </p>
          <a href="#contacto" className="inline-flex items-center gap-2 bg-gradient-to-r from-brand-cyan to-brand-purple hover:from-brand-cyan/90 hover:to-brand-purple/90 text-white font-bold px-6 md:px-8 py-3 md:py-4 rounded-xl transition-all duration-300 shadow-[0_0_30px_rgba(0,255,255,0.2)] hover:shadow-[0_0_40px_rgba(139,47,201,0.3)] hover:scale-105" data-id="element-381">
            {language === 'es' ? 'Hablemos y te ayudamos a elegir' : "Let's talk and we'll help you choose"}
            <ChevronRight className="w-5 h-5" data-id="element-382" />
          </a>
        </motion.div>
      </div>
    </section>;
}